import { buildPath, buildPathForApi } from "./API";
import {
  ActivateUserURL,
  AddBookingForClientURL,
  AddBookingsURL,
  AddClientsDataURL,
  AddClientsSubscriptionDataURL,
  AddExerciseURL,
  UpdateExerciseURL,
  AddNewAssessmentURL,
  AddPaymentCategoryURL,
  AddServiceDataURL,
  AddSubscriptionsDataURL,
  AddClientGroupBookingURL,
  AddTaskURL,
  AddUserURL,
  adminUsersTableDataURL,
  ApproveDeclineExerciseURL,
  AssignAssessmentToClients,
  AssignProgramToClientURL,
  AssignToClientsURL,
  BlueprintsAddImport,
  bluePrintsTableDataURL,
  CancelBookingsURL,
  ChangePlanURL,
  EditAdminLandingPageDataURL,
  EditAssessmentURL,
  EditClientSubscriptionDataURL,
  CancelClientSubscriptionDataURL,
  EditProfileURL,
  EditUserURL,
  FCMTokenURL,
  ForgotPasswordURL,
  GetAccountOwnerDetailsURL,
  GetAdminApproveExerciseDataURL,
  GetAdminLandingPageDataURL,
  GetAllAssignedProgramAndSubscriptionDataURL,
  GetAssessmentByIdURL,
  GetAssessmentsURL,
  GetAssignToClientsCountURL,
  GetBlueprintURL,
  DeleteBlueprintURL,
  GetBookingByIdURL,
  GetGroupBookingByIdURL,
  GetBookingsByDateURL,
  GetCheckInFormResponseURL,
  GetCheckInFormsListURL,
  GetClientDetailURL,
  GetClientsActiveProgramURL,
  GetClientsDataURL,
  GetClientViewProgramDetailsURL,
  UnassignProgramFromClientURL,
  GetCommunicationDataURL,
  GetCurrentProgramAndSubscriptionDataURL,
  GetEditClientSubscriptionDataURL,
  GetExercisesURL,
  GetFilterExercisesURL,
  GetFormsDataURL,
  GetFormURL,
  GetFullClientOverviewDetailsURL,
  GetLandingPageDataURL,
  GetLicensesURL,
  GetMarketHubDataURL,
  GetPaymentCategoryListURL,
  GetPaymentConnectionStatusURL,
  GetPlanDetailsURL,
  GetProgramURL,
  GetRecordSessionDetailsURL,
  GetServiceDataById,
  GetServicesAndSubscriptionsDataURL,
  GetServicesDataURL,
  GetSetupDataURL,
  GetSubscriptionDataById,
  GetSubscriptionsDataURL,
  GetTaskByIdURL,
  GetTasksURL,
  GetUpcomingBookingsForClientURL,
  GetUserAvailabilityURL,
  GetUserDetailURL,
  GetUsersURL,
  InactivateUserURL,
  OnBoardingGetAllPlanURL,
  ValidatePlanCodeURL,
  OnBoardingPaymentURL,
  OnBoardingSelectPlanURL,
  OnBoardingTabsDetailURL,
  OnBoardingTermsAndConditionsURL,
  OnBoardingUserDetailsURL,
  PayNowForSubscriptionURL,
  RecordSessionActionURL,
  RescheduleBookingsURL,
  ResetPasswordFromSettingsURL,
  ResetPasswordURL,
  ResendVerificationURL,
  SaveAdminLandingPageDataURL,
  SaveAsBlueprintsURL,
  SaveCommunicationDetailsURL,
  SaveSetupDetailsURL,
  ScheduleCheckInFormURL,
  SetPasswordURL,
  SetPaymentConnectionDataURL,
  SignInURL,
  SignUpURL,
  StartClientSessionURL,
  SubmitUserResponseLandingPageURL,
  UpdateBillingURL,
  UpdateBookingStatusURL,
  UpdateTaskBookingURL,
  UpdateClientDataURL,
  UpdateServiceDataById,
  UpdateSubscriptionDataById,
  UserDetailsURL,
  VerifyOTPURL,
  ExtendTrialURL,
  GetNewLeadClientDetailsURL,
  InitiateNewLeadOnboardingURL,
  GetEngagementChartDataURL,
  GetSessionsChartDataURL,
  GetSessionNotesListURL,
  GetSessionNoteDetailURL,
  ExportBlueprintURL,
  GetImportBlueprintFieldsMappingsURL,
  ImportBlueprintFileURL,
  GetMetricsChartDataURL,
  AssignAssessmentToClientFromClientProfile,
  RemoveClientAssessmentURL,
  ArchiveClientAssessmentURL,
  GetSessionFeedbackFormResponse,
  GetAssessmentsChartDataURL,
  RecordAssessmentURL,
  GetAssignedAssessmentDetailsURL,
  ImportClientsFileURL,
  GetImportClientsFieldsMappingsURL,
  ClientsAddImportURL,
  GetCoachListURL,
  assignCoachURL,
  GetDashboardOverviewCountsURL,
  GetDashboardPaymentsURL,
  ExportPaymentDataURL,
  GetClientEngagementDonutChartDataURL,
  GetWorkoutCompletedDonutChartDataURL,
  GetUpcomingSessionsDataURL,
  GetAllNotificationsDataURL,
  ClearNotificationURL,
  ClearAllNotificationsURL,
  ClearNotificationGroupURL,
  MuteNotificationForTodayURL,
  MuteNotificationFromAllClientTodayURL,
  GetQuickFilterCountsURL,
  GetUpcomingPaymentsURL,
  GetUpcomingPaymentsFilterCountsURL,
  SendTaskReminderURL,
  CompleteTaskURL,
  DeleteTaskURL,
  PayOverdueAmountNowURL,
  CreateNewBlankSessionURL,
  GetGroupSubscriptionsURL,
  GetClientsBySubscriptionURL,
  SendBookingConfirmationReminderURL,
  InactivateClientURL,
  ReactivateClientURL,
  StopPlanURL,
  CancelScheduledPlanChangeURL,
  GetClientClosureRequestURL,
  ApproveClientClosureRequestURL,
  RejectClientClosureRequestURL,
  ApproveSubscriptionCancellationURL,
  RejectSubscriptionCancellationURL,
  DeleteBlueprintFileURL,
  GetTourProgressURL,
  UpdateTourStepURL,
  CompleteTourURL,
  UpdateChecklistURL,
  ResetTourURL,
  AddManualTransactionURL,
  GetFuturePaymentsURL,
  PausePaymentsURL,
  SkipPaymentURL,
  AdjustPaymentAmountURL,
  GetPaymentAdjustmentsURL,
  RemovePaymentAdjustmentURL,
  GetInvoicesURL,
  GetInvoiceByIdURL,
  CreateInvoiceURL,
  UpdateInvoiceURL,
  DeleteInvoiceURL,
  SendInvoiceURL,
  SendInvoiceReminderURL,
  MarkInvoicePaidURL,
  CancelInvoiceURL,
  ReconcileInvoiceURL,
  GetInvoiceStatusCountsURL,
  GetInvoicePDFURL,
  GenerateInvoiceFromPaymentURL,
  BulkGenerateInvoicesURL,
} from "./apiURLs";
import axiosInstance, { axiosFileUploadInstance } from "./axiosInstance";

export const AuthorizationActions = {
  signIn: (params) => axiosInstance.post(SignInURL, { ...params }),

  signUp: (params) => axiosInstance.post(SignUpURL, { ...params }),

  onBoardingTabsDetail: () => axiosInstance.get(OnBoardingTabsDetailURL),

  onBoardingUserDetails: (params) => axiosInstance.put(OnBoardingUserDetailsURL, { ...params }),

  onBoardingGetAllPlan: () => axiosInstance.get(OnBoardingGetAllPlanURL),

  validatePlanCode: (params) => axiosInstance.post(ValidatePlanCodeURL, { ...params }),

  onBoardingSelectPlan: (params) => axiosInstance.post(OnBoardingSelectPlanURL, { ...params }),

  onBoardingGetAllTermsAndConditions: () => axiosInstance.get(OnBoardingTermsAndConditionsURL),

  onBoardingTermsAndConditions: (params) => axiosInstance.put(OnBoardingTermsAndConditionsURL, { ...params }),

  onboardingPayment: (params) => axiosInstance.post(OnBoardingPaymentURL, { ...params }),

  userDetails: (id) => axiosInstance.get(buildPath(UserDetailsURL, { id })),

  forgotPassword: (params) => axiosInstance.post(ForgotPasswordURL, { ...params }),

  resendVerification: (params) => axiosInstance.post(ResendVerificationURL, { ...params }),

  resetPassword: (params) => axiosInstance.post(ResetPasswordURL, { ...params }),

  verifyOTP: (params) => axiosInstance.post(VerifyOTPURL, { ...params }),

  setPassword: (params) => axiosInstance.post(SetPasswordURL, { ...params }),

  sendTokenToServer: (params) => axiosInstance.post(FCMTokenURL, { ...params }),

  deleteTokenFromServer: async (params) => axiosInstance.delete(FCMTokenURL, { data: params }),

  extendTrial: () => axiosInstance.post(ExtendTrialURL),
};

export const BlueprintsActions = {
  getBlueprintsData: async (params) => axiosInstance.get(buildPathForApi(bluePrintsTableDataURL, params)),
  exportPDF: async (rowId, params) => {
    const dynamicRoute = buildPath(ExportBlueprintURL, { rowId });
    const mainUrl = buildPathForApi(dynamicRoute, { ...params });
    return axiosInstance.get(mainUrl, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/pdf",
      },
    });
  },
  exportExcel: (rowId, params) => {
    const dynamicRoute = buildPath(ExportBlueprintURL, { rowId });
    const mainUrl = buildPathForApi(dynamicRoute, { ...params });
    return axiosInstance.get(mainUrl, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    });
  },
  deleteBlueprint: async (blueprintId) => axiosInstance.delete(buildPath(DeleteBlueprintURL, { blueprintId })),
};

export const FormActions = {
  getFormsData: async (params) => axiosInstance.get(buildPathForApi(GetFormsDataURL, params)),

  createForm: (params) => axiosInstance.post(GetFormsDataURL, params),

  editForm: (params, formId) => axiosInstance.put(buildPath(GetFormURL, { formId }), { ...params }),

  getForm: (formId) => axiosInstance.get(buildPath(GetFormURL, { formId })),
};

export const AdminUsersActions = {
  getAdminUsersData: async (params) => axiosInstance.get(buildPathForApi(adminUsersTableDataURL, params)),
};

export const ExerciseActions = {
  addExercise: async (params) =>
    axiosInstance.post(AddExerciseURL, params, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  updateExercise: async (exerciseId, params) =>
    axiosInstance.put(buildPath(UpdateExerciseURL, { exerciseId }), params, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  getExercises: async (params) => axiosInstance.get(buildPathForApi(GetExercisesURL, params)),

  getFilterExercises: async (params) => axiosInstance.get(buildPathForApi(GetFilterExercisesURL, params)),

  getAdminApproveExerciseData: (params) =>
    axiosInstance.get(buildPathForApi(GetAdminApproveExerciseDataURL, { ...params })),

  approveDeclineExercise: (params) => axiosInstance.post(ApproveDeclineExerciseURL, { ...params }),
};

export const DynamicBuilderActions = {
  assignToClients: (params) => axiosInstance.post(AssignToClientsURL, { ...params }),

  getBlueprint: (programId) => axiosInstance.get(buildPath(GetBlueprintURL, { programId })),

  getProgram: (programId) => axiosInstance.get(buildPath(GetProgramURL, { programId })),

  saveAsBlueprints: (params) => axiosInstance.post(SaveAsBlueprintsURL, { ...params }),

  updateBlueprint: (params) => {
    // Validate blueprintId is a non-empty string (UUID format check is optional)
    const { blueprintId, ...rest } = params;
    if (!blueprintId || typeof blueprintId !== "string" || !/^[0-9a-fA-F-]{36}$/.test(blueprintId)) {
      console.error("Invalid blueprintId for updateBlueprint:", blueprintId);
      throw new Error("Invalid blueprintId for updateBlueprint");
    }
    // Log outgoing payload for debugging
    console.log("updateBlueprint URL:", buildPath(GetBlueprintURL, { programId: blueprintId }));
    console.log("updateBlueprint body:", rest);
    return axiosInstance.put(buildPath(GetBlueprintURL, { programId: blueprintId }), rest);
  },
};

export const BlueprintsImportActions = {
  importBlueprintsFile: (formData) => axiosFileUploadInstance.post(ImportBlueprintFileURL, formData),

  getBlueprintsData: (params) => axiosInstance.get(buildPathForApi(GetImportBlueprintFieldsMappingsURL, params)),

  importBlueprintAddProgram: (params) => axiosInstance.post(BlueprintsAddImport, params),

  deleteBlueprintFile: (params) => axiosInstance.post(DeleteBlueprintFileURL, { ...params }),
};

export const ClientActions = {
  importClientsFile: (formData) => axiosFileUploadInstance.post(ImportClientsFileURL, formData),

  getClientsFileFieldsData: (params) => axiosInstance.get(buildPathForApi(GetImportClientsFieldsMappingsURL, params)),

  importClients: (params) => axiosInstance.post(ClientsAddImportURL, params),

  getUsers: () => axiosInstance.get(GetUsersURL),

  addUser: (params) => axiosInstance.post(AddUserURL, { ...params }),

  editUser: (params, userId) => {
    const url = buildPath(EditUserURL, { id: userId });
    return axiosInstance.put(url, { ...params });
  },

  getLicensesDetails: () => axiosInstance.get(GetLicensesURL),

  inactivateUser: (userId) => axiosInstance.delete(buildPath(InactivateUserURL, { id: userId })),

  activateUser: (userId) => axiosInstance.put(buildPath(ActivateUserURL, { id: userId })),

  getUserById: (userId) => axiosInstance.get(buildPath(GetUserDetailURL, { id: userId })),

  getClientsData: async (params) => axiosInstance.get(buildPathForApi(GetClientsDataURL, params)),

  addClient: (params) => axiosInstance.post(AddClientsDataURL, { ...params }),

  getCheckInFormsList: (params) => axiosInstance.get(buildPathForApi(GetCheckInFormsListURL, { ...params })),

  scheduleCheckInForm: (params) => axiosInstance.post(ScheduleCheckInFormURL, { ...params }),

  getCheckInFormResponse: (params) => axiosInstance.get(buildPathForApi(GetCheckInFormResponseURL, { ...params })),

  // Fetch Eway credentials for mobile payment
  getEwayCredentialsEnvironment: () => axiosInstance.get("/clients/eway/cred-environment"),
  GetClientsActiveProgram: (clientId, params) => {
    console.log(params);
    const url = buildPath(GetClientsActiveProgramURL, { clientId });
    return axiosInstance.get(buildPathForApi(url, { ...params }));
  },

  StartClientSession: (clientId, params) => {
    const url = buildPath(StartClientSessionURL, { clientId });
    return axiosInstance.post(url, params);
  },

  getNewLeadClientDetails: (clientId) => axiosInstance.get(buildPath(GetNewLeadClientDetailsURL, { clientId })),

  deleteLeadClient: (clientId) => axiosInstance.delete(buildPath("/clients/new-lead/:clientId", { clientId })),

  initiateNewLeadClient: (params) => axiosInstance.post(InitiateNewLeadOnboardingURL, { ...params }),
};

export const SubscriptionsActions = {
  getSubscriptions: () => axiosInstance.get(GetSubscriptionsDataURL),

  getSubscriptionsData: async (params) => axiosInstance.get(buildPathForApi(GetSubscriptionsDataURL, params)),

  getSubscriptionDataById: (subscriptionId) =>
    axiosInstance.get(buildPath(GetSubscriptionDataById, { subscriptionId })),

  updateSubscriptionDataById: (params, subscriptionId) => {
    const url = buildPath(UpdateSubscriptionDataById, { subscriptionId });
    return axiosInstance.put(url, { ...params });
  },

  addSubscription: (params) => axiosInstance.post(AddSubscriptionsDataURL, { ...params }),

  getPaymentCategoryList: () => axiosInstance.get(GetPaymentCategoryListURL),

  addPaymentCategory: (params) => axiosInstance.post(AddPaymentCategoryURL, params),
};

export const ClientProfileActions = {
  getClientDetails: (clientId) => axiosInstance.get(buildPath(GetClientDetailURL, { id: clientId })),

  inActivateClient: (clientId) => axiosInstance.put(buildPath(InactivateClientURL, { clientId })),

  reActivateClient: (clientId) => axiosInstance.put(buildPath(ReactivateClientURL, { clientId })),

  getBlueprintsData: async (params) => axiosInstance.get(buildPathForApi(bluePrintsTableDataURL, params)),

  // Fetch Eway credentials for mobile payment
  getEwayCredentialsEnvironment: () => axiosInstance.get("/clients/eway/cred-environment"),
  GetClientsActiveProgram: (clientId, params) => {
    console.log(params);
    const url = buildPath(GetClientsActiveProgramURL, { clientId });
    return axiosInstance.get(buildPathForApi(url, { ...params }));
  },

  assignProgramToClient: (clientId, params) => {
    const url = buildPath(AssignProgramToClientURL, { id: clientId });
    return axiosInstance.post(url, { ...params });
  },
  //add client group booking in clientBooking talbe
  addClientGroupBooking: (clientId, params) => {
    const url = buildPath(AddClientGroupBookingURL, { id: clientId });
    return axiosInstance.post(url, { ...params });
  },
  getCurrentProgramAndSubscriptionData: (clientId) =>
    axiosInstance.get(buildPath(GetCurrentProgramAndSubscriptionDataURL, { clientId })),

  getAllAssignedProgramAndSubscriptionData: (clientId) =>
    axiosInstance.get(buildPath(GetAllAssignedProgramAndSubscriptionDataURL, { clientId })),

  getUpcomingBookingsForClient: (clientId) =>
    axiosInstance.get(buildPath(GetUpcomingBookingsForClientURL, { clientId })),

  GetClientViewProgramDetails: (clientId, programId) => {
    const url = buildPath(GetClientViewProgramDetailsURL, { clientId, programId });
    return axiosInstance.get(url);
  },

  unassignProgramFromClient: (clientId, programId) => {
    const url = buildPath(UnassignProgramFromClientURL, { clientId, programId });
    return axiosInstance.delete(url);
  },

  GetRecordSessionDetails: (clientId, sessionId) => {
    const url = buildPath(GetRecordSessionDetailsURL, { clientId, sessionId });
    return axiosInstance.get(url);
  },

  RecordSessionAction: (clientId, sessionId, payload) => {
    const url = buildPath(RecordSessionActionURL, { clientId, sessionId });
    return axiosInstance.put(url, payload);
  },

  createNewBlankSession: (params) => axiosInstance.post(CreateNewBlankSessionURL, params),

  addClientSubscription: (clientId, params) => {
    const url = buildPath(AddClientsSubscriptionDataURL, { id: clientId });
    return axiosInstance.post(url, { ...params });
  },

  editClientSubscription: (clientId, subscriptionId, params) => {
    const url = buildPath(EditClientSubscriptionDataURL, { clientId, subscriptionId });
    return axiosInstance.put(url, { ...params });
  },

  cancelClientSubscription: (clientId, subscriptionId, params) => {
    const url = buildPath(CancelClientSubscriptionDataURL, { clientId, subscriptionId });
    return axiosInstance.put(url, { ...params });
  },
  getSubscriptionDataById: (clientId, subscriptionId) => {
    const url = buildPath(GetEditClientSubscriptionDataURL, { clientId, subscriptionId });
    return axiosInstance.get(url);
  },
  getClientDetials: (clientId) => axiosInstance.get(buildPath(GetClientDetailURL, { id: clientId })),

  getFullClientOverviewDetails: (clientId) =>
    axiosInstance.get(buildPath(GetFullClientOverviewDetailsURL, { clientId })),

  payNowForSubscription: (clientId, subscriptionId, params) => {
    const url = buildPath(PayNowForSubscriptionURL, { clientId, subscriptionId });
    return axiosInstance.post(url, { ...params });
  },

  updateClientDetails: (clientId, params) => {
    const url = buildPath(UpdateClientDataURL, { clientId });
    return axiosInstance.put(url, { ...params });
  },

  addBookingsForClient: async (clientId, params) => {
    const url = buildPath(AddBookingForClientURL, { clientId });
    return axiosInstance.post(url, { ...params });
  },

  getEngagementChartData: (params) => axiosInstance.get(buildPathForApi(GetEngagementChartDataURL, { ...params })),

  getSessionsChartData: (params) => axiosInstance.get(buildPathForApi(GetSessionsChartDataURL, { ...params })),

  getMetricsChartData: (params) => axiosInstance.get(buildPathForApi(GetMetricsChartDataURL, { ...params })),

  getAssessmentsChartData: (params) => axiosInstance.get(buildPathForApi(GetAssessmentsChartDataURL, { ...params })),

  getSessionNotes: async (clientId) => axiosInstance.get(buildPath(GetSessionNotesListURL, { clientId })),

  getSessionNoteDetails: async (clientId, sessionId) =>
    axiosInstance.get(buildPath(GetSessionNoteDetailURL, { clientId, sessionId })),

  assignAssessment: async (params) => axiosInstance.post(AssignAssessmentToClientFromClientProfile, { ...params }),

  removeClientAssessment: async (clientAssessmentId) =>
    axiosInstance.delete(buildPath(RemoveClientAssessmentURL, { id: clientAssessmentId })),

  archiveClientAssessment: async (clientAssessmentId) =>
    axiosInstance.patch(buildPath(ArchiveClientAssessmentURL, { id: clientAssessmentId })),

  getSessionFeedbackForm: async (clientId, sessionId) =>
    axiosInstance.get(buildPath(GetSessionFeedbackFormResponse, { clientId, sessionId })),

  getAssignedAssessmentDetails: async (params) =>
    axiosInstance.get(buildPathForApi(GetAssignedAssessmentDetailsURL, params)),

  recordAssessment: (params) =>
    axiosInstance.post(RecordAssessmentURL, params, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  getCoachList: () => axiosInstance.get(GetCoachListURL),

  assignCoachToClient: async (clientId, params) => {
    const url = buildPath(assignCoachURL, { clientId });
    return axiosInstance.post(url, { ...params });
  },
  // Fetch a client's card token
  getClientCardToken: (clientId) => axiosInstance.get(`/clients/${clientId}/card-token`),
  // Fetch a client's payment token
  getClientPaymentToken: (clientId) => axiosInstance.get(`/clients/${clientId}/payment-token`),

  // Subscription Payment Adjustments
  getFuturePayments: (subscriptionId, monthsAhead = 12) => {
    const url = buildPath(GetFuturePaymentsURL, { subscriptionId });
    return axiosInstance.get(`${url}?monthsAhead=${monthsAhead}`);
  },

  pausePayments: (subscriptionId, params) => {
    const url = buildPath(PausePaymentsURL, { subscriptionId });
    return axiosInstance.post(url, params);
  },

  skipPayment: (subscriptionId, params) => {
    const url = buildPath(SkipPaymentURL, { subscriptionId });
    return axiosInstance.post(url, params);
  },

  adjustPaymentAmount: (subscriptionId, params) => {
    const url = buildPath(AdjustPaymentAmountURL, { subscriptionId });
    return axiosInstance.post(url, params);
  },

  getPaymentAdjustments: (subscriptionId) => {
    const url = buildPath(GetPaymentAdjustmentsURL, { subscriptionId });
    return axiosInstance.get(url);
  },

  removePaymentAdjustment: (adjustmentId) => {
    const url = buildPath(RemovePaymentAdjustmentURL, { adjustmentId });
    return axiosInstance.delete(url);
  },
};

export const ServicesActions = {
  getServicesData: async (params) => axiosInstance.get(buildPathForApi(GetServicesDataURL, params)),

  getServiceDataById: (serviceId) => axiosInstance.get(buildPath(GetServiceDataById, { serviceId })),

  addService: (params) =>
    axiosInstance.post(AddServiceDataURL, params, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  updateServiceDataById: (params, serviceId) => {
    const url = buildPath(UpdateServiceDataById, { serviceId });
    return axiosInstance.put(url, params, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};

export const AssessmentActions = {
  getAssessmentsData: async (params) => axiosInstance.get(buildPathForApi(GetAssessmentsURL, params)),

  getAssessmentById: async (assessmentId) => axiosInstance.get(buildPath(GetAssessmentByIdURL, { id: assessmentId })),

  addNewAssessment: async (params) => axiosInstance.post(AddNewAssessmentURL, { ...params }),

  assignAssessmentToClients: async (params, assessmentId) => {
    const url = buildPath(AssignAssessmentToClients, { id: assessmentId });
    return axiosInstance.post(url, { ...params });
  },

  getAssignToClientsCount: async (assessmentId) =>
    axiosInstance.get(buildPath(GetAssignToClientsCountURL, { id: assessmentId })),

  editAssesment: (params, assessmentId) => {
    const url = buildPath(EditAssessmentURL, { id: assessmentId });
    return axiosInstance.put(url, { ...params });
  },
};

export const SettingsActions = {
  getAccountOwnerDetails: async () => axiosInstance.get(GetAccountOwnerDetailsURL),

  resetAccountOwnerPassword: async (params) => axiosInstance.put(ResetPasswordFromSettingsURL, { ...params }),

  updateBillingPayAndUpdateToken: async (params) => axiosInstance.post(UpdateBillingURL, { ...params }),

  updateBilling: async (params) => axiosInstance.put(UpdateBillingURL, { ...params }),

  payOverdueAmountNow: () => axiosInstance.post(PayOverdueAmountNowURL),

  getCommunicationData: async () => axiosInstance.get(GetCommunicationDataURL),

  saveCommunicationDetails: async (params) => axiosInstance.post(SaveCommunicationDetailsURL, { ...params }),

  getSetupData: async () => axiosInstance.get(GetSetupDataURL),

  saveSetupDetails: async (params) => axiosInstance.post(SaveSetupDetailsURL, { ...params }),

  editProfile: async (params) =>
    axiosInstance.put(EditProfileURL, params, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  getPaymentConnectionStatus: async () => axiosInstance.get(GetPaymentConnectionStatusURL),

  getActiveEwaySubscriptions: async () => axiosInstance.get("/settings/payment-connection/eway-subscriptions"),

  disconnectEwayPayment: async () => axiosInstance.delete("/settings/payment-connection"),

  setPaymentConnectionData: async (params) => axiosInstance.post(SetPaymentConnectionDataURL, { ...params }),

  getPlanDetails: async (params) => axiosInstance.get(buildPathForApi(GetPlanDetailsURL, params)),

  changePlan: async (params) => axiosInstance.post(ChangePlanURL, { ...params }),

  stopPlan: () => axiosInstance.post(StopPlanURL),

  cancelScheduledPlanChange: () => axiosInstance.post(CancelScheduledPlanChangeURL),
};

export const TasksActions = {
  getAllTasksData: async (params) => axiosInstance.get(buildPathForApi(GetTasksURL, params)),

  getTaskById: async (taskId) => axiosInstance.get(buildPath(GetTaskByIdURL, { id: taskId })),

  addTask: async (params) => axiosInstance.post(AddTaskURL, { ...params }),

  sendTaskReminder: (taskId) => axiosInstance.post(buildPath(SendTaskReminderURL, { id: taskId })),

  completeTask: (taskId) => axiosInstance.post(buildPath(CompleteTaskURL, { id: taskId })),

  deleteTask: (taskId) => axiosInstance.delete(buildPath(DeleteTaskURL, { id: taskId })),
};

export const MarketHubActions = {
  getMarketHubData: async (params) => axiosInstance.get(buildPathForApi(GetMarketHubDataURL, params)),
};

export const AdminLandingPageActions = {
  getLandingPageData: async () => axiosInstance.get(GetAdminLandingPageDataURL),

  saveLadingPageData: async (params) =>
    axiosInstance.post(SaveAdminLandingPageDataURL, params, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  editLadingPageData: async (params) =>
    axiosInstance.put(EditAdminLandingPageDataURL, params, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
};

export const LandingPageActions = {
  getLandingPageData: async (params) => axiosInstance.get(buildPathForApi(GetLandingPageDataURL, params)),

  submitUserResponseLandingPageData: async (params) =>
    axiosInstance.post(SubmitUserResponseLandingPageURL, params, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
};

export const CalendarActions = {
  addBooking: (params) => axiosInstance.post(AddBookingsURL, { ...params }),

  getServicesAndSubscriptions: async (params) =>
    axiosInstance.get(buildPathForApi(GetServicesAndSubscriptionsDataURL, params)),

  getBookingsByDate: async (params) => axiosInstance.get(buildPathForApi(GetBookingsByDateURL, params)),

  getBookingsById: (bookingId, occurrenceDate) => {
    const url = buildPath(GetBookingByIdURL, { bookingId });
    const params = occurrenceDate ? { occurrence_date: occurrenceDate } : {};
    return axiosInstance.get(url, { params });
  },

  getGroupBookingsById: (bookingId, occurrenceDate) => {
    const url = buildPath(GetGroupBookingByIdURL, { bookingId });
    const params = occurrenceDate ? { occurrence_date: occurrenceDate } : {};
    return axiosInstance.get(url, { params });
  },

  updateBookingStatus: (params, bookingId) => {
    const url = buildPath(UpdateBookingStatusURL, { bookingId });
    return axiosInstance.put(url, { ...params });
  },

  updateTask: (params, bookingId) => {
    const url = buildPath(UpdateTaskBookingURL, { bookingId });
    return axiosInstance.put(url, { ...params });
  },

  rescheduleBooking: (params, bookingId) => {
    const url = buildPath(RescheduleBookingsURL, { bookingId });
    return axiosInstance.put(url, { ...params });
  },

  cancelBooking: (params, bookingId) => {
    const url = buildPath(CancelBookingsURL, { bookingId });
    return axiosInstance.delete(url, { data: params });
  },

  getUserAvailability: async (params) => axiosInstance.get(buildPathForApi(GetUserAvailabilityURL, params)),

  getGroupSubscriptions: () => axiosInstance.get(GetGroupSubscriptionsURL),

  getClientsBySubscription: (subscriptionId) =>
    axiosInstance.get(buildPath(GetClientsBySubscriptionURL, { subscriptionId })),

  sendBookingConfirmationReminder: (bookingId) =>
    axiosInstance.post(buildPath(SendBookingConfirmationReminderURL, { bookingId })),
};

export const DashboardActions = {
  getDashboardOverviewCount: async (params) =>
    axiosInstance.get(buildPathForApi(GetDashboardOverviewCountsURL, params)),

  getDashboardPaymentsData: async (params) => axiosInstance.get(buildPathForApi(GetDashboardPaymentsURL, params)),

  exportPaymentPDF: async (params) => {
    const mainUrl = buildPathForApi(ExportPaymentDataURL, { ...params });
    return axiosInstance.get(mainUrl, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/pdf",
      },
    });
  },

  exportPaymentExcel: (params) => {
    const mainUrl = buildPathForApi(ExportPaymentDataURL, { ...params });
    return axiosInstance.get(mainUrl, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    });
  },

  getAllNotificationsData: () => axiosInstance.get(GetAllNotificationsDataURL),

  clearNotification: (notificationId) => axiosInstance.delete(buildPathForApi(ClearNotificationURL, notificationId)),

  clearAllNotifications: () => axiosInstance.delete(ClearAllNotificationsURL),

  clearNotificationGroup: (params) => axiosInstance.post(ClearNotificationGroupURL, params),

  muteNotificationToday: (params) => axiosInstance.post(MuteNotificationForTodayURL, params),

  muteNotificationFromAllClientToday: (params) => axiosInstance.post(MuteNotificationFromAllClientTodayURL, params),

  getClientEngagementDonutChartData: async (params) =>
    axiosInstance.get(buildPathForApi(GetClientEngagementDonutChartDataURL, params)),

  getWorkoutCompletedDonutChartData: async (params) =>
    axiosInstance.get(buildPathForApi(GetWorkoutCompletedDonutChartDataURL, params)),

  getUpcomingSessionsDataURL: async (params) => axiosInstance.get(buildPathForApi(GetUpcomingSessionsDataURL, params)),

  getQuickFiltersCountURL: async (params) => axiosInstance.get(buildPathForApi(GetQuickFilterCountsURL, params)),

  getUpcomingPayments: async (params) => axiosInstance.get(buildPathForApi(GetUpcomingPaymentsURL, params)),

  getUpcomingPaymentsFilterCounts: async () => axiosInstance.get(GetUpcomingPaymentsFilterCountsURL),
};
export const ClosureActions = {
  getClosuresData: async (params) => axiosInstance.get(buildPathForApi(GetClientClosureRequestURL, params)),
  ApproveClientClosureRequest: async (params) => axiosInstance.post(ApproveClientClosureRequestURL, params),
  RejectClientCLosureRequest: async (params) => axiosInstance.post(RejectClientClosureRequestURL, params),
};

export const SubscriptionActions = {
  ApproveSubscriptionCancellation: async (params) => axiosInstance.post(ApproveSubscriptionCancellationURL, params),
  RejectSubscriptionCancellation: async (params) => axiosInstance.post(RejectSubscriptionCancellationURL, params),
};

export const TaskActions = {
  CompleteTask: async (taskId) => axiosInstance.post(buildPath(CompleteTaskURL, { id: taskId })),
};

export const TransactionsAction = {
  AddManualTransaction: async (params) => axiosInstance.post(AddManualTransactionURL, params),
};

export const TourActions = {
  getTourProgress: async () => axiosInstance.get(GetTourProgressURL),

  updateTourStep: async (stepIndex) => axiosInstance.put(UpdateTourStepURL, { stepIndex }),

  completeTour: async () => axiosInstance.put(CompleteTourURL),

  updateChecklistItems: async (items) => axiosInstance.put(UpdateChecklistURL, { items }),

  resetTour: async () => axiosInstance.put(ResetTourURL),
};

export const InvoiceActions = {
  getInvoices: async (params) => axiosInstance.get(buildPathForApi(GetInvoicesURL, params)),

  getInvoiceById: async (id) => axiosInstance.get(buildPath(GetInvoiceByIdURL, { id })),

  createInvoice: async (data) => axiosInstance.post(CreateInvoiceURL, data),

  updateInvoice: async (id, data) => axiosInstance.put(buildPath(UpdateInvoiceURL, { id }), data),

  deleteInvoice: async (id) => axiosInstance.delete(buildPath(DeleteInvoiceURL, { id })),

  sendInvoice: async (id) => axiosInstance.post(buildPath(SendInvoiceURL, { id })),

  sendInvoiceReminder: async (id) => axiosInstance.post(buildPath(SendInvoiceReminderURL, { id })),

  markInvoicePaid: async (id, paidDate) =>
    axiosInstance.post(buildPath(MarkInvoicePaidURL, { id }), { paid_date: paidDate }),

  cancelInvoice: async (id) => axiosInstance.post(buildPath(CancelInvoiceURL, { id })),

  reconcileInvoice: async (id, transactionId) =>
    axiosInstance.post(buildPath(ReconcileInvoiceURL, { id }), { transaction_id: transactionId }),

  getInvoiceStatusCounts: async () => axiosInstance.get(GetInvoiceStatusCountsURL),

  getInvoicePDF: async (id) =>
    axiosInstance.get(buildPath(GetInvoicePDFURL, { id }), {
      responseType: "blob",
      headers: { "Content-Type": "application/pdf" },
    }),

  generateFromPayment: async (data) => axiosInstance.post(GenerateInvoiceFromPaymentURL, data),

  bulkGenerate: async (data) => axiosInstance.post(BulkGenerateInvoicesURL, data),
};

// Default export for backward compatibility
export default {
  ...AuthorizationActions,
  ...BlueprintsActions,
  ...FormActions,
  ...AdminUsersActions,
  ...ExerciseActions,
  ...DynamicBuilderActions,
  ...BlueprintsImportActions,
  ...ClientActions,
  ...SubscriptionsActions,
  ...ClientProfileActions,
  ...ServicesActions,
  ...AssessmentActions,
  ...SettingsActions,
  ...TasksActions,
  ...MarketHubActions,
  ...AdminLandingPageActions,
  ...LandingPageActions,
  ...CalendarActions,
  ...DashboardActions,
  ...ClosureActions,
  ...SubscriptionActions,
  ...TaskActions,
  ...TourActions,
  ...InvoiceActions,
};
